module.exports = __webpack_public_path__ + "static/media/tighter_environmental.15fe832c.png";